import React, { JSX } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { JobHeaderProps } from './jobInfoTypes';

export function JobHeader(props: JobHeaderProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: props.isMobile || props.variant === 'small' ? 'column' : 'row',
        minWidth: 0,
        '& > div > div > :first-of-type': { fontWeight: 'bold', whiteSpace: 'nowrap' },
        '& > div > div > :last-of-type': { mb: 0.75, mr: 1 },
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: props.isMobile ? 'row' : 'column',
          flexGrow: 1,
          gap: 1,
          minWidth: 0,
        }}
      >
        <JobMeta label="Company" value={props.activeJob.company} isMobile={props.isMobile} />
        <JobMeta label="Title" value={props.activeJob.title} isMobile={props.isMobile} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: ['small', 'minimal'].includes(String(props.variant)) ? '100%' : '75%',
        }}
      >
        {!props.isMobile && props.activeJob.summary && <JobSummary {...props} />}
      </Box>
    </Box>
  );
}

function JobMeta(props: { label: string; value?: string; isMobile: boolean }): JSX.Element | null {
  if (!props.value) return null;

  return (
    <Box sx={{ fontSize: '0.8rem', minWidth: 0, flex: props.isMobile ? 1 : 'initial' }}>
      <Box>{props.label}</Box>
      <Box
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        title={props.value}
      >
        {props.value}
      </Box>
    </Box>
  );
}

function JobSummary(props: JobHeaderProps): JSX.Element {
  return (
    <Box sx={{ fontSize: '0.8rem' }}>
      <Box>Summary</Box>
      <Box sx={{ minHeight: props.variant === 'small' ? '5rem' : 'inherit' }}>
        <Typography
          ref={props.descriptionRef}
          variant="body1"
          color="text.secondary"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: props.isDescriptionExpanded ? 'unset' : 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: 1.5,
            fontSize: '0.8rem !important',
          }}
        >
          {props.activeJob.summary}
        </Typography>
        {props.shouldShowMoreButton && (
          <Link
            component="button"
            variant="body2"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              props.setIsDescriptionExpanded(!props.isDescriptionExpanded);
            }}
            sx={{
              color: props.primaryColor,
              textDecoration: 'none',
              cursor: 'pointer',
              fontSize: '0.725rem',
              fontWeight: 500,
              mt: 0.5,
              display: 'block',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            [{props.isDescriptionExpanded ? 'less' : 'more'}]
          </Link>
        )}
      </Box>
    </Box>
  );
}
